import styled from 'styled-components';
import { Card, Button, Accordion } from 'react-bootstrap';

export const AccordionContainer = styled.div``;

export const ChevronStyled = styled.img``;

export const IconFilterStyled = styled.img`
  margin-right: 20px;
`;

export const ButtonStyled = styled.button`
  font-family: 'Gotham';
  font-weight: 300;
  font-size: 10px;
  color: #c91422;
  border: none;
  background-color: #fff;
  display: flex;
  min-width: 110px;
`;

export const ButtonArrowStyled = styled.button`
  position: absolute;
  top: -1px;
  right: -1px;
  background: #4a90e2;
  border-radius: 11.5px 6px 0px 11.5px;
  padding: 5px 8px;
  border: none;
  transition: all 0.3s;
  display: flex;
  height: 24.4px;
  align-items: center;
`;

export const CleanStyled = styled.img`
  margin-right: 5px;
`;

export const ActionsStyled = styled.div`
  display: flex;
  align-items: center;
  margin-top: 26px;
`;

export const ImageStyled = styled.img`
  transform: rotate(180deg);
`;

export const AccordionStyled = styled(Accordion)`
  &:first-child {
    padding-bottom: 25px;
    margin-bottom: 23px;
    border-bottom: 1px solid #e4e8f0;
  }
`;

export const AccordionButtonStyled = styled(Button)`
  font-family: 'Gotham';
  font-weight: 300;
  font-size: 20px;
  line-height: 24px;
  color: #475466;
  display: block;
  width: 100%;
  text-align: left;
  padding: 0;
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  z-index: 999;

  & + ${ChevronStyled} {
    transition: transform 0.3s;
    position: absolute;
    right: 0;
    top: 9px;
  }

  &.collapsed + ${ChevronStyled} {
    transform: rotate(180deg);
  }

  &:hover,
  &:focus {
    text-decoration: none;
    color: #475466;
    box-shadow: none;
  }
`;

export const CardStyled = styled(Card)`
  overflow: visible !important;
  border: none;
  .card-header,
  .card-body {
    padding: 0;
  }
  .card-header {
    border-bottom: none;
    background-color: #fff;
    margin-bottom: 23px !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;

export const FilterStyled = styled.aside`
  background: #ffffff;
  border: 1px solid #e7e8f2;
  border-radius: 6px;
  padding: 26px 18px;
  height: 100%;
  position: relative;
  left: 0;
  transition: 0.3s ease-in-out;

  &.closed {
    position: relative;
    left: calc(-100% - 33px);
  }
`;



export const ButtonConfirmStyled = styled.button`
  width: 100%;
  border: none;
  background: #4a90e2;
  border-radius: 5px;
  font-family: 'Gotham';
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  color: #ffffff;
  padding: 7px;
`;

